import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { handleApiError } from "@/utils/apiErrorHandler";
import { clearError } from "./errorSlice";


// Helper function to build query string
const buildQueryString = (query: any) => {
  const params = new URLSearchParams();
  if (query.groupID !== undefined) params.append("groupID", query.groupID);
  if (query.version !== undefined) params.append("version", query.version);
  if (query.page !== undefined) params.append("page", query.page);
  if (query.size !== undefined) params.append("size", query.size);
  if (query.designation !== undefined) params.append("designation", query.designation);
  if (query.specialty !== undefined) params.append("premiumSpecialty", query.specialty);
  if (query.geographicArea !== undefined)
    params.append("geographicArea", query.geographicArea);
  if (query.search !== undefined) params.append("search", query.search);
  return params.toString();
};

// Define fetchGroupDesignations
export const fetchGroupDesignations = createAsyncThunk(
  "resultsBySpecialty/fetchGroupDesignations",
  async ({ query }: { query: any }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(clearError());
      const queryString = buildQueryString(query); // Build query string
      const response = await axios.get(`/papi/secure/groups/designations?${queryString}`);
      return response.data;
    } catch (error) {
      handleApiError(error as AxiosError, "resultsBySpecialty", dispatch);
      return rejectWithValue(error instanceof Error ? error.message : "Failed to fetch group designations");
    }
  }
);

const initialState = {
  designationFilters: [],
  specialtyFilters: [],
  geographicAreaFilters: [],
  assessments: [],
  totalItems: 0,
  specialtyGroups: [],
  loading: false,
  currentPage: 0,
  previousQuery: null as string | null,
  error: null as string | null,
};

const resultsBySpecialtySlice = createSlice({
  name: "resultsBySpecialty",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupDesignations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupDesignations.fulfilled, (state, action) => {
        state.loading = false;
        state.designationFilters = action.payload.data.designationFilters || [];
        state.specialtyFilters = action.payload.data.specialtyFilters || [];
        state.geographicAreaFilters =
          action.payload.data.geographicAreaFilters || [];
        state.assessments = action.payload.data.assessments || [];
        state.totalItems = action.payload.totalItems || 0;
        state.currentPage = action.payload.currentPage;
        state.previousQuery = action.meta.arg.query;
        state.specialtyGroups = action.payload.data.specialtyGroups || [];
      })
      .addCase(fetchGroupDesignations.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch group designations";
      });
  },
});

export default resultsBySpecialtySlice.reducer;
